<ul>
  <li *ngFor="let message of errorMessages">{{ message }}</li>
</ul>
